import axios from 'src/api/client/axios'

interface ApiResetChannelHeritageParams {
  userToken: string
  environmentDataId: string
  serverPath: string
}

export const ApiResetChannelHeritage = async ({ serverPath, ...params }:ApiResetChannelHeritageParams) => {
  const res = await axios.post(`https://${serverPath}/sialdPMS/web/resourcescrossorigin/seasonmanual/resetchannelheritage`, params)
  return res.data
}
